import firebase from 'firebase/compat/app'
import "firebase/compat/auth"
import "firebase/compat/database"
import 'firebase/compat/storage';
import 'firebase/compat/firestore';


var app = firebase.initializeApp({
  apiKey: "AIzaSyBfchHJUMUb2kfjWtywpogqyvtAb7sZA5s",
  authDomain: "genava-7d1fd.firebaseapp.com",
  projectId: "genava-7d1fd",
  storageBucket: "genava-7d1fd.appspot.com",
  messagingSenderId: "401288358916",
  appId: "1:401288358916:web:71bed2fe65f747db975951"
})
export const storage = app.storage();

export var auth = app.auth();
export const db = app.firestore();
export {firebase}
const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

export const signInWithGoogle = () => auth.signInWithPopup(provider);
export default app
